var EmptyNode = (function () {
    function EmptyNode() {
    }
    Object.defineProperty(EmptyNode.prototype, "name", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmptyNode.prototype, "length", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    EmptyNode.prototype.get = function (path) {
        return this;
    };
    EmptyNode.prototype.set = function (path, value) {
        return this;
    };
    EmptyNode.prototype.exists = function (path) {
        return false;
    };
    EmptyNode.prototype.forEach = function (callback) {
    };
    EmptyNode.prototype.toString = function () {
        return null;
    };
    EmptyNode.prototype.toRaw = function () {
        return null;
    };
    EmptyNode.prototype.toArray = function () {
        return [];
    };
    EmptyNode.prototype.isEmpty = function () {
        return true;
    };
    EmptyNode.prototype.toDate = function () {
        return null;
    };
    EmptyNode.prototype.toInteger = function () {
        return null;
    };
    EmptyNode.prototype.toFloat = function () {
        return null;
    };
    EmptyNode.prototype.toBoolean = function () {
        return null;
    };
    EmptyNode.prototype.read = function (path) {
        return null;
    };
    EmptyNode.prototype.write = function (path, value) {
        return this;
    };
    Object.defineProperty(EmptyNode.prototype, "path", {
        get: function () {
            throw new Error("Not implemented");
        },
        enumerable: true,
        configurable: true
    });
    return EmptyNode;
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EmptyNode;
